/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/phone/sheets/QaPhoneStatusSheet.tsx
 * FILE_ID: JOBHUB-QA-PHONE-STATUS-001
 * PURPOSE: Four-value item-status sheet. Pass writes done.
 */
import { MobileSheet, QaItemStatusButtons, type QaItemStatusWrite } from '@quotech/ui'

export function QaPhoneStatusSheet({
  open,
  onClose,
  value,
  onChange,
}: {
  open: boolean
  onClose: () => void
  value: string
  onChange: (status: QaItemStatusWrite) => void
}) {
  return (
    <MobileSheet open={open} onClose={onClose} title="Status" size="full">
      <div className="p-4">
        <QaItemStatusButtons
          currentStatus={value}
          onSelect={(status) => {
            onChange(status)
            onClose()
          }}
        />
      </div>
    </MobileSheet>
  )
}
